<template>
    <ValidationObserver ref="observer"
                        tag="form"
                        class="row d-flex mx-2"
                        @submit.prevent="submit">
        <div class="col-sm-6 py-4">
            <ValidationProvider tag="div"
                                vid="userGroup"
                                class="mb-4"
                                mode="lazy"
                                rules="required"
                                :customMessages="{required: 'Norādi darbinieka grupas nosaukumu.'}"
                                v-slot="{errors}">
                <label for="userGroup" class="d-block text-secondary text-left mb-0">Darbinieku grupas nosaukums</label>
                <input type="text" id="userGroup" class="w-100 py-1 ds-input" v-model="userGroup.name">
                <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
        <CustomButton class="w-25 mb-4 ds-btn--success" :btn-text="userGroup._id ? 'Saglabāt izmaiņas' : 'Pievienot'"
                      :is-loading="isActiveRequest"/>
    </ValidationObserver>
</template>
<script>
    import {mapGetters, mapActions, mapMutations} from 'vuex';

    import {ValidationObserver, ValidationProvider, extend} from 'vee-validate';
    import {required} from 'vee-validate/dist/rules';

    import CustomButton from '@/components/global/CustomButton';
    import * as userGroupStoreTypes from '../../vuex/modules/user/modules/user-groups/user-group.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types';
    import {UserGroup} from "../../vuex/modules/user/modules/user-groups/user-group.models";

    export default {
        name: 'users-groups-base-form',
        components: {
            CustomButton,
            ValidationProvider,
            ValidationObserver,
        },
        data() {
            return {
                userGroup: {...this.$store.state.userGroup.selectedUserGroup},
            }
        },
        created() {
            extend('required', required);
        },
        computed: {
            ...mapGetters('userGroup', {
                /** @type {boolean|*} */
                isActiveRequest: userGroupStoreTypes.GET_IS_ACTIVE_REQUEST,
            }),
        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapActions('userGroup', {
                /** @type {function|*} */
                addUserGroup: userGroupStoreTypes.ACTION_ADD_USER_GROUP,
                /** @type {function|*} */
                updateUserGroup: userGroupStoreTypes.ACTION_UPDATE_USER_GROUP,
            }),
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if (!isValid) {
                    return;
                }

                try {
                    if (this.userGroup._id) {
                        await this.updateUserGroup(this.userGroup);
                        this.reset();
                        return this.setAlertData({type: 'primary', message: 'Darbinieka Grupas izmaiņas saglabātas!'});
                    }

                    await this.addUserGroup({companyId: this.$route.params.companyId, userGroup: this.userGroup});
                    this.setAlertData({type: 'primary', message: 'Darbinieka Grupa pievienota!'});
                    this.reset();
                } catch (error) {
                    this.$refs.observer.setErrors({[error.field]: [error.message]});
                }
            },
            reset() {
                this.userGroup = new UserGroup();
                this.$refs.observer.reset();
                this.$emit('finished');
            },
        },
    }
</script>